import { html } from '@shared/utils/rendering/html';

import { FilterTypes } from '@shared/components/advanced-filters/filter-types';
import Chip from '@shared/components/chips';

import { UserRoles, RemoteSystems } from '../../../constants/admin/admin-lists.constants';

const activeChipMap = {
    inactive: { text: 'Include Deleted', value: 0, css: 'bg-red' },
};

export const UserSearchOptions = [
    { value: 0, text: 'All' },
    { value: 1, text: 'ID' },
    { value: 2, text: 'Name' },
    { value: 3, text: 'Email' },
    { value: 4, text: 'Manager' },
];

export const UserFilterGroups = {
    role: 'roleId',
    system: 'remoteSystemId',
    deleted: 'includeDeleted',
};

export const UserFilterDefaults = {
    selectedFilters: {}, // This is important
    defaultSearchOption: { value: 0, text: 'All' },
    filters: [
        {
            label: 'User Role',
            identifier: UserFilterGroups.role,
            display: true,
            multiple: false,
            type: FilterTypes.STATIC_SELECT.id,
            options: Object.values(UserRoles).map((role) => ({
                value: role.id,
                text: html`<${Chip}
                    css="hover"
                    type="chip"
                    label=${{
                        text: role.name,
                    }}
                />`,
            })),
        },
        {
            label: 'System',
            identifier: UserFilterGroups.system,
            display: true,
            multiple: false,
            type: FilterTypes.STATIC_SELECT.id,
            options: Object.values(RemoteSystems).map((system) => ({
                value: system.systemId,
                text: html`<${Chip}
                    css="hover"
                    type="chip"
                    label=${{
                        text: system.systemName,
                    }}
                />`,
            })),
        },
        {
            label: 'Include Deleted',
            identifier: UserFilterGroups.deleted,
            display: true,
            multiple: false,
            type: FilterTypes.STATIC_SELECT.id,
            options: [
                {
                    value: activeChipMap.inactive.value,
                    text: html`<${Chip}
                        css="hover ${activeChipMap.inactive.css}"
                        type="indicator-chip"
                        label=${{
                            text: activeChipMap.inactive.text,
                        }}
                    />`,
                },
            ],
        },
    ],
};

// public Guid? RoleId { get; set; }
//     public int? RemoteSystemId { get; set; }
//     public bool? IncludeDeleted { get; set; }
